import { Link } from "react-router-dom";
import { Card } from "../ui/card";
import { Button } from "../ui/button";
import { Sparkles, Lock, ArrowRight } from "lucide-react";

const PLAN_LABEL = { pro: "Pro", club: "Club" };

/**
 * Inline banner shown when a feature is locked by the current plan.
 * Use inside a Card or as a section overlay on the feature page.
 *
 * Props:
 *  - feature: human-readable description of what's locked
 *  - requiredPlan: 'pro' | 'club'
 *  - compact?: boolean — slimmer version for inline placement
 */
export default function UpgradeBanner({ feature, requiredPlan = "pro", compact = false }) {
  const planLabel = PLAN_LABEL[requiredPlan] || "Pro";
  if (compact) {
    return (
      <div className="flex items-center gap-3 p-3 rounded-xl border border-amber-200 bg-amber-50" data-testid="upgrade-banner-compact">
        <Lock size={16} className="text-amber-600 shrink-0" />
        <span className="text-sm text-amber-900 flex-1">
          <strong>{feature}</strong> è disponibile dal piano <strong>{planLabel}</strong>.
        </span>
        <Link to="/app/pricing">
          <Button size="sm" className="bg-amber-500 hover:bg-amber-600 text-white">
            Upgrade <ArrowRight size={12} className="ml-1" />
          </Button>
        </Link>
      </div>
    );
  }
  return (
    <Card
      className="p-8 text-center bg-gradient-to-br from-sky-50 via-white to-amber-50 border-amber-200"
      data-testid="upgrade-banner"
    >
      <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-amber-100 text-amber-600 mb-4">
        <Sparkles size={26} />
      </div>
      <h2 className="font-heading font-bold text-2xl mb-2">Sblocca {feature}</h2>
      <p className="text-slate-600 max-w-md mx-auto mb-5">
        Questa funzionalità è inclusa nel piano <strong>{planLabel}</strong>.
        Passa a un piano superiore per accedere subito.
      </p>
      <div className="flex gap-2 justify-center">
        <Link to="/app/pricing">
          <Button size="lg" className="bg-sky-500 hover:bg-sky-600 text-white" data-testid="upgrade-banner-cta">
            Vedi i piani <ArrowRight size={14} className="ml-1" />
          </Button>
        </Link>
        <Link to="/app/billing">
          <Button size="lg" variant="outline">
            Il mio abbonamento
          </Button>
        </Link>
      </div>
    </Card>
  );
}
